import { createSlice } from "@reduxjs/toolkit";
import { adminChangePassword, editAdminProfileImage, getUser, signInSubmit, signOutSubmit } from "./authService";

const initialState = {
    signInDetails: {
        isSignInLoading: null,
        isSignedIn: null,
        signInMessage: null,
    },

    userDetails: {
        isUserDetailsLoading: null,
        isUserDetails: null,
        userDetailsMessage: null,
        roleName: null,
        isLoggedIn: false,
        isLoading: false,
        hasCheckedAuth: false,
        details: {
            id: null,
            email: null,
            full_name: null,
            image_url: null,
            phone_number: null,
        },
    },

    adminImageUpdate: {
        imageUpdateStatus: null,
        message: null
    },
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(signInSubmit.pending, (state) => {
            state.signInDetails = {
                ...initialState.signInDetails,
                isSignInLoading: true,
                signInMessage: "Loading",
            };
        });

        builder.addCase(signInSubmit.rejected, (state, action) => {
            state.signInDetails = {
                ...initialState.signInDetails,
                isSignInLoading: false,
                isSignedIn: false,
                signInMessage: action.payload,
            };
        });

        builder.addCase(signInSubmit.fulfilled, (state, action) => {
            state.signInDetails = {
                ...initialState.signInDetails,
                isSignInLoading: false,
                isSignedIn: true,
                signInMessage: action.payload,
            };
        });
        builder.addCase(getUser.pending, (state, action) => {
            state.userDetails = {
                isUserDetailsLoading: true,
                isUserDetails: false,
                userDetailsMessage: "Loading",
                details: initialState.userDetails.details,
                isLoggedIn: false,
                roleName: null,
            };
        });

        builder.addCase(getUser.rejected, (state, action) => {
            state.userDetails = {
                isUserDetailsLoading: false,
                isUserDetails: false,
                userDetailsMessage: action.payload,
                details: initialState.userDetails.details,
                isLoggedIn: false,
                roleName: null,
                hasCheckedAuth: true,
            };
        });

        builder.addCase(getUser.fulfilled, (state, action) => {
            state.userDetails = {
                isUserDetailsLoading: false,
                isUserDetails: true,
                userDetailsMessage: "Successfully loaded user details",
                details: action.payload,
                isLoggedIn: true,
                roleName: action.payload.role.name,
                hasCheckedAuth: true,
            };
        });

        builder.addCase(signOutSubmit.pending, (state) => {
            state.userDetails.isLoading = true;
            state.userDetails.message = "Logging out...";
        });
        builder.addCase(signOutSubmit.fulfilled, (state) => {
            state.userDetails = {
                isLoggedIn: false,
                isLoading: false,
                message: "Logout successful.",
            };
        });
        builder.addCase(signOutSubmit.rejected, (state, action) => {
            state.userDetails.isLoading = false;
            state.userDetails.message = action.payload?.message || "Logout failed.";
        });
        builder.addCase(editAdminProfileImage.pending, (state) => {
            state.adminImageUpdate.imageUpdateStatus = 'loading';
            state.adminImageUpdate.message = null;
        });
        builder.addCase(editAdminProfileImage.fulfilled, (state, action) => {
            state.adminImageUpdate.imageUpdateStatus = 'success';
            state.adminImageUpdate.message = null;
        });
        builder.addCase(editAdminProfileImage.rejected, (state, action) => {
            state.adminImageUpdate.imageUpdateStatus = 'failed';
            state.adminImageUpdate.message = action.payload || 'Failed to update image';
        });
    }
});

export const { login, logout } = authSlice.actions;
export const selectUserDetails = (state) => state.auth.userDetails;
export const editAdminImage = (state) => state.auth.adminImageUpdate;
export const editAdminPassword = (state) => state.auth.adminChangePassword;
export default authSlice.reducer;
